/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * A presentation of credentials. [Terminology](https://www.w3.org/TR/vc-data-model/#dfn-presentations).
 */
export interface Presentation {
    /**
     * The [Multibase](https://www.w3.org/TR/cid/#multibase)-encoded sha2-256 [Multihash](https://www.w3.org/TR/cid/#multihash) value.
     *
     * See [Resource Integrity](https://www.w3.org/TR/vc-data-integrity/#resource-integrity).
     */
    digestMultibase: string;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    id: string;
    /** A list of linked credential references. */
    linkedCredentialRefs?: Truvity.LinkedRef[];
    /** A list of presentation types. */
    type: string[];
}
